export const clientId =
  '200032265591-vcod021cajjd643jehqcltu784p4htl7.apps.googleusercontent.com';
export const uri = `${
  process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://localhost:4000'
}/graphql`;
export const hostedDomain = 'vazco.eu';
export const commitHash = process.env.REACT_APP_COMMIT_HASH;
